// Client route path builders. Employee routes live under `/`, dispatcher under `/dispo`,
// admin under `/admin`.
export const routes = {
  login: "/login",
  loginVerify: "/login/verify",
  // employee
  home: "/",
  entryNew: (date?: string) => (date ? `/entries/new?date=${date}` : "/entries/new"),
  entry: (id: string) => `/entries/${id}`,
  absences: "/absences",
  absence: (id: string) => `/absences/${id}`,
  vacationNew: "/absences/vacation/new",
  azkNew: "/absences/azk/new",
  sickNew: "/absences/sick/new",
  profile: "/profile",
  notifications: "/notifications",
  // dispatcher
  dispo: "/dispo",
  dispoTimes: (params?: { employee?: number; week?: string }) => {
    const q = new URLSearchParams();
    if (params?.employee) q.set("employee", String(params.employee));
    if (params?.week) q.set("week", params.week);
    const s = q.toString();
    return s ? `/dispo/times?${s}` : "/dispo/times";
  },
  dispoAbsences: "/dispo/absences",
  dispoAbsence: (id: string) => `/dispo/absences?id=${id}`,
  dispoAbsencesOf: (employee: number) => `/dispo/absences?tab=all&employee=${employee}`,
  dispoEmployees: "/dispo/employees",
  dispoSync: "/dispo/sync",
  // admin
  adminSync: "/admin/sync",
  adminUsers: "/admin/users",
  adminSettings: "/admin/settings",
} as const;

// Where a role lands after login.
export function homeFor(role: "employee" | "dispatcher" | "admin"): string {
  return role === "employee" ? routes.home : routes.dispo;
}
